import { concat } from '../observable/concat';
import { popScheduler } from '../util/args';
import { Observable } from '../Observable';
export function startWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var scheduler = popScheduler(values);
    return function (source) {
        return new Observable(function (subscriber) {
            (scheduler ? concat(values, source, scheduler) : concat(values, source)).subscribe(subscriber);
        });
    };
}
//# sourceMappingURL=startWith.js.map